import { computed, Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalNotificationsConfig, GlobalNotificationsConfigResponse } from '@ceres/domain';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class GlobalNotificationsBannerService {
    private readonly http = inject(HttpClient);
    private readonly cacheRefreshInterval = 5 * 60 * 1000;
    private readonly configState = signal<GlobalNotificationsConfig | null>(null);
    private readonly apiUrl = `${environment.edgeService}/global-notifications`;

    public readonly config = this.configState.asReadonly();
    public readonly isBannerVisible = computed(() => {
        const config = this.configState();

        if (!config || !config.isActive) {
            return false;
        }

        const now = Date.now();
        const startDate = Date.parse(config.bannerStartDateTime);
        const endTime = Date.parse(config.endTime);

        if (Number.isNaN(startDate) || Number.isNaN(endTime)) {
            return false;
        }

        return now >= startDate && now < endTime;
    });

    constructor() {
        this.startCacheRefresh();
    }

    public refreshConfig(): void {
        this.http
            .get<GlobalNotificationsConfigResponse>(this.apiUrl)
            .pipe(catchError(() => of(null)))
            .subscribe((config) => this.configState.set(config));
    }

    private startCacheRefresh(): void {
        this.refreshConfig();
        interval(this.cacheRefreshInterval).subscribe(() => this.refreshConfig());
    }
}
